import { createAction } from '@reduxjs/toolkit';

const saveLuggageFormValues = createAction(
  'ui/sealink/ferryFlow/saveLuggageFormValues'
);

const clearLuggageByTypeIds = createAction(
  'ui/sealink/ferryFlow/clearLuggageByTypeIds'
);

export { saveLuggageFormValues, clearLuggageByTypeIds };
